import React, {Component} from 'react';
import {Grid, Col, Row, Button, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
import Select   from 'react-select'
import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';


export default class AdminRecordSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
             filterOptions: {
                perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                 fromFD:_.isUndefined(this.props.location.query.fromFD) ? '' : moment(this.props.location.query.fromFD),
                 toFD:_.isUndefined(this.props.location.query.toFD) ? '' : moment(this.props.location.query.toFD),
                 Statuses:  _.isUndefined(this.props.location.query.Statuses) ?  [] : _.isArray(this.props.location.query.Statuses) ? _.map(this.props.location.query.Statuses, function (status) {
                     return _.find(config.warehousePickupStatusMap, {value:status})
                }) : [_.find(config.warehousePickupStatusMap, {value:this.props.location.query.Statuses})],

            }
        };

    };

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};
        console.log('filterOptions', filterOptions);
        var queryParams = {};
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (!_.isUndefined(filterOptions.Statuses)) {
            queryParams.Statuses = _.map(filterOptions.Statuses, 'value')
        }
        if (filterOptions.fromFD &&  moment(filterOptions.fromFD, 'MM-DD-YYYY HH:mm',true).isValid() ) {
            queryParams.fromFD = filterOptions.fromFD.toISOString()
        }
        if (filterOptions.toFD &&  moment(filterOptions.toFD, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
            queryParams.toFD = filterOptions.toFD.toISOString()
        }

        if (filterOptions.Deleted) {
            queryParams.Deleted = filterOptions.Deleted;
        }
        return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }


    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    render() {
        var self = this;
        return (
            <div className="product-search-block">
                <Row  >
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Button className="btn btn-primary" onClick={this.props.toggleAllRecordsSelection}>
                            {this.props.selectAllRecords ? 'Clear selection' : 'Select all' }
                        </Button>
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>


                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>

                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            clearable={true}
                            multi
                            placeholder="Status"
                            options={config.warehousePickupStatusMap }
                             onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Statuses: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.Statuses}
                        />

                    </Col>
                </Row>
                <Row  >

                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              fromFD: option,
                                          }
                                      }, function () {
                                          this.props.search();
                                      });
                                  }}
                                  inputProps={{ placeholder: 'From fulfilled at' }}

                                  value={this.state.filterOptions.fromFD}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'}  timeFormat={false}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              toFD: option,
                                          }
                                      }, function () {
                                          this.props.search();
                                      });
                                  }}
                                  inputProps={{ placeholder: 'To fulfilled at' }}
                                  value={this.state.filterOptions.toFD}
                        />
                    </Col>


                    <Col md={6} xs={6} className="top10  ">
                        <button className="btn btn-primary pull-right" disabled={this.props.pending} onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>

                </Row>

            </div>
        );

    }
}



